import { FC, useEffect, useMemo, useState } from "react";

import { Collapse } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";
import { QuestionnaireGetResponse } from "capitalrx-types";

import { QuestionnaireContent } from "@/components";

interface QuestionnaireFormProps {
  readonly answersOpen: boolean;
  readonly questionnaire: QuestionnaireGetResponse;
}

export const QuestionnaireFormContent: FC<QuestionnaireFormProps> = ({
  answersOpen = false,
  questionnaire,
}) => {
  const [expanded, setIsExpanded] = useState(false);

  const sortedQuestions = useMemo(() => {
    if (!questionnaire?.questions) {
      return undefined;
    }

    return [...questionnaire.questions].sort((a, b) => a.order_index - b.order_index);
  }, [questionnaire?.questions]);

  useEffect(() => {
    setIsExpanded(answersOpen);
  }, [answersOpen]);

  return (
    <Collapse
      alignCaret="left"
      expanded={expanded}
      keepHiddenContentInDOM
      onToggleExpand={() => setIsExpanded((expanded) => !expanded)}
      testId="questionnaire-collapse"
      title={
        <Shelf>
          <Body><Semibold testId={`questionnaire-title-${questionnaire?.id}`}>{questionnaire?.title}</Semibold></Body>
          <Shelf.Spacer />
        </Shelf>
      }>

      {!!sortedQuestions?.length && (
        <QuestionnaireContent
          isReadonly={false}
          questionnaire={questionnaire}
          sortedQuestions={sortedQuestions}
        />
      )}
    </Collapse>
  );
};
